import * as React from 'react';
import * as styles from "../ContentOrganizerGovernance.css";
import { IAIcon } from "../../icon/Icon";
import { inject, observer } from 'mobx-react';
import { LocalizationService } from '../../../services/LocalizationService';
import { ContentOrganizerGovernanceStore } from '../store';

export interface IPagingProps {
  getNextPage: () => void;
  getPreviousPage: () => void;
  getPage?: (number: number) => void;
  pageMode?: string;
  contentOrganizerGovernanceStore?: ContentOrganizerGovernanceStore;
}

@inject('contentOrganizerGovernanceStore')
@observer
export class Paging extends React.Component<IPagingProps> {

  constructor(props: IPagingProps) {
    super(props);
  }

  public render(): JSX.Element {
    const pageNumbers = this.getPagingNumbers();

    return this.props.contentOrganizerGovernanceStore.isMobile ?
      <div
        className={styles.IA_ContentOrganizerGov_paging}
      >
        <div
          className={styles.IA_ContentOrganizerGov_loadMoreButton}
          style={{
            color: this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor
          }}
          onClick={() => {
            this.props.getNextPage();
          }}
        >
          {new LocalizationService().strings.Phonebook_LoadMore}
        </div>
      </div>
      :
      <div
        className={styles.IA_ContentOrganizerGov_paging}
      >
        {(this.props.pageMode === undefined || this.props.pageMode === "arrow") &&
          <div>
            <IAIcon
              url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Left/SVG/ic_fluent_chevron_left_48_regular.svg"
              size={18}
              color={this.props.contentOrganizerGovernanceStore.pageNumber != 1 ? (this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor) : "#eeeeee"}
              style={{
                cursor: this.props.contentOrganizerGovernanceStore.pageNumber != 1 ? "pointer" : "default",
                float: "left",
                marginLeft: "calc(50% - 18px)"
              }}
              onClick={() => {
                if (this.props.contentOrganizerGovernanceStore.isFetchingPages) {
                  return;
                }
                if (this.props.contentOrganizerGovernanceStore.pageNumber != 1) {
                  this.props.contentOrganizerGovernanceStore.isFetchingPages = true;
                  this.props.contentOrganizerGovernanceStore.pageNumber--;
                  this.props.getPreviousPage();
                }
              }}
            />
            <IAIcon
              url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Right/SVG/ic_fluent_chevron_right_48_regular.svg"
              size={18}
              color={(Math.floor(this.props.contentOrganizerGovernanceStore.siteList?.length / this.props.contentOrganizerGovernanceStore.pageSize) !== 1) || (this.props.contentOrganizerGovernanceStore.siteListCount === this.props.contentOrganizerGovernanceStore.pageNumber) ? "#eeeeee" : (this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor)}
              style={{
                cursor: (Math.floor(this.props.contentOrganizerGovernanceStore.siteList?.length / this.props.contentOrganizerGovernanceStore.pageSize) !== 1) || (this.props.contentOrganizerGovernanceStore.siteListCount === this.props.contentOrganizerGovernanceStore.pageNumber) ? "default" : "pointer",
                float: "left"
              }}
              onClick={() => {
                if (this.props.contentOrganizerGovernanceStore.isFetchingPages || Math.floor(this.props.contentOrganizerGovernanceStore.siteList?.length / this.props.contentOrganizerGovernanceStore.pageSize) !== 1) {
                  return;
                } else {
                  this.props.contentOrganizerGovernanceStore.isFetchingPages = true;
                  this.props.contentOrganizerGovernanceStore.pageNumber++;
                  this.props.getNextPage();
                }
              }}
            />
          </div>
        }
        {this.props.pageMode != undefined && this.props.pageMode === "number" &&
          <div style={{}}>
            <IAIcon
              url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Left/SVG/ic_fluent_chevron_left_48_regular.svg"
              size={18}
              color={this.props.contentOrganizerGovernanceStore.pageNumber != 1 ? (this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor) : "#eeeeee"}
              style={{
                cursor: this.props.contentOrganizerGovernanceStore.pageNumber != 1 ? "pointer" : "default",
                float: "left",
                marginLeft: "calc(50% - 18px)"
              }}
              onClick={() => {
                if (this.props.contentOrganizerGovernanceStore.isFetchingPages) {
                  return;
                }
                if (this.props.contentOrganizerGovernanceStore.pageNumber != 1) {
                  this.props.contentOrganizerGovernanceStore.isFetchingPages = true;
                  this.props.contentOrganizerGovernanceStore.pageNumber--;
                  this.props.getPreviousPage();
                }
              }}
            />
            {pageNumbers}
            <IAIcon
              url="https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Right/SVG/ic_fluent_chevron_right_48_regular.svg"
              size={18}
              color={(Math.floor(this.props.contentOrganizerGovernanceStore.siteList?.length / this.props.contentOrganizerGovernanceStore.pageSize) !== 1) || (this.props.contentOrganizerGovernanceStore.siteListCount === this.props.contentOrganizerGovernanceStore.pageNumber) ? "#eeeeee" : (this.props.contentOrganizerGovernanceStore.hasDarkBackground ? "#ffffff" : this.props.contentOrganizerGovernanceStore.highlightColor)}
              style={{
                cursor: (Math.floor(this.props.contentOrganizerGovernanceStore.siteList?.length / this.props.contentOrganizerGovernanceStore.pageSize) !== 1) || (this.props.contentOrganizerGovernanceStore.siteListCount === this.props.contentOrganizerGovernanceStore.pageNumber) ? "default" : "pointer",
                float: "left"
              }}
              onClick={() => {
                if (this.props.contentOrganizerGovernanceStore.isFetchingPages || Math.floor(this.props.contentOrganizerGovernanceStore.siteList?.length / this.props.contentOrganizerGovernanceStore.pageSize) !== 1) {
                  return;
                } else {
                  this.props.contentOrganizerGovernanceStore.isFetchingPages = true;
                  this.props.contentOrganizerGovernanceStore.pageNumber++;
                  this.props.getNextPage();
                }
              }}
            />
          </div>
        }
      </div>
  }

  public getPagingNumbers(): JSX.Element {
    const pagesCount = Math.ceil(this.props.contentOrganizerGovernanceStore.siteListCount / this.props.contentOrganizerGovernanceStore.pageSize);
    let element: JSX.Element[] = [];
    for (let i = 1; i <= pagesCount; i++) {
      if (pagesCount > 9) {
        if (i <= 3) {
          element.push( i === 3 ? (<span key={i}>{i}</span>) : (<span key={i}>{i}</span>));  
        }
        if (i > 9 && this.props.contentOrganizerGovernanceStore.pageNumber > 9 && i === this.props.contentOrganizerGovernanceStore.pageNumber) {
          element.push((<span key={"ellipsisStart"}>...</span>));
          element.push((<span key={i-1}>{i-1}</span>));
          element.push((<span key={i}>{i}</span>));
          element.push((<span key={i+1}>{i+1}</span>));
          element.push((<span key={"ellipsisEnd"}>...</span>));
        }
        if (i >= pagesCount-2) {
          element.push((<span key={i}>{i}</span>)); 
        }
      } else {
        element.push((<span key={i}>{i}</span>));
      }
    }

    return (
      <span style={{ float: "left", marginLeft: 10, marginRight: 5, marginTop: -3 }}>
        {element.map((el, i) =>
          <span
            style={{ 
              cursor: this.props.contentOrganizerGovernanceStore.pageNumber === (i + 1) ? "default" : "pointer", 
              marginRight: 5,
              color: this.props.contentOrganizerGovernanceStore.pageNumber === (i + 1) ? "#eee" : this.props.contentOrganizerGovernanceStore.highlightColor 
            }}
            onClick={() => this.props.getPage(i + 1)}>
            {el}
          </span>)}
      </span>
    )
  }
}